import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import { Logger, EndpointService } from '@app/core';
import { DocumentoAnexo } from '@app/shared/models/documento.model';

const log = new Logger('FlowService');

export interface DowloadFile {
  path: string;
  name: string;
}

@Injectable()
export class DocumentsRecordsPreviewService{
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  
  /**
   *Obtiene los documentos del expediente
   *
   * @param {number} expediente
   * @return {*}  {Observable<any>}
   * @memberof DocumentsRecordsPreviewService
   */
  getDocumentExpedient(expediente: number): Observable<any>{
    return new Observable(obs => {
      this.http.get<any>(this.api.get('document_expedient', [expediente])).subscribe(
        stage => {
         obs.next(stage);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }


  /**
   * Servicio para descargar los documentos
   *
   * @param {number} idDocumento
   * @return {*}  {Observable<any>}
   * @memberof DocumentsRecordsPreviewService
   */
  dowloadFile(idDocumento: number): Observable<any> {
    return new Observable(obs => {
      this.http
        .skipErrorHandler()
        .get(this.api.get('docsInstance', [idDocumento]), {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403 && err.status !== 500) {
              this.toastr.warning(err.error['message'], 'Fallo de descarga');
            }else{
              this.toastr.error(err.error['message'], 'Fallo de descarga');
            }
            obs.error(err);
          }
        );
    });
  }

/**
   * Descargar documento anexado
   *
   * @param {number} idAttached
   * @returns {Observable<DowloadFile>}
   * @memberof DocumentsRecordsPreviewService
   */
 getDownloadAttachedDocument(idAttached: number): Observable<DowloadFile> {
  return new Observable(obs => {
    this.http.get<DowloadFile>(this.api.get('downloadAttachedDocument', [idAttached])).subscribe(
      file => {
        obs.next(file);
      },
      err => {
        obs.error(err);
      }
    );
  });
}
/**
   * Consulta de los documentos anexados a una tarea
   *
   * @param {number} idDocument
   * @returns {Observable<DocumentoAnexo>}
   * @memberof DocumentsRecordsPreviewService
   */
 getAttachedDocument(idDocument: number): Observable<DocumentoAnexo[]> {
  return new Observable(obs => {
    this.http.get<DocumentoAnexo[]>(this.api.get('attachedDocumentCustom', [idDocument])).subscribe(
      documentsAttached => {
        obs.next(documentsAttached);
      },
      err => {
        obs.error(err);
      }
    );
  });
}
} // End class



// WEBPACK FOOTER //
// ./src/app/shared/documents-records-preview/shared/documents-records-preview.data.service.ts